import { render, staticRenderFns } from "./imgLightbox.vue?vue&type=template&id=207a0fb7&scoped=true&"
import script from "./imgLightbox.vue?vue&type=script&lang=js&"
export * from "./imgLightbox.vue?vue&type=script&lang=js&"
import style0 from "./imgLightbox.vue?vue&type=style&index=0&id=207a0fb7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207a0fb7",
  null
  
)

export default component.exports